import { EntityService, GlobalService } from "app/core/services";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { SearchSinesterRequest } from "../model/requests/searchSinesterRequest";
import { MigratedSinester } from "../model/MigratedSinester";


@Injectable()
export class MigratedSinesterService {
    constructor(
        private http: GlobalService,
        private entityService: EntityService
    ) { }


    search(request: SearchSinesterRequest): Observable<MigratedSinester[]> {
        const url = `MigratedSinester/Search`;
        return this.http
            .post(url, request)
            .map((res) => this.entityService.extractData<MigratedSinester[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const sinester = new MigratedSinester();
                    return this.entityService.copy(dataItem, sinester);
                });
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/migratedsinester.service.ts